// Código de error del backend -> texto accionable. Las claves son el español
// (mecanismo i18n del repo). Se mapea por `code`; sin código se cae al estado
// HTTP y por último a un genérico. Nunca se muestra el `message` crudo del
// backend: puede traer detalles internos.

const BY_CODE = {
  INVALID_PHONE: "El teléfono no es válido. Revisa el número e incluye el código de país.",
  PHONE_EDIT_FORBIDDEN: "No tienes permiso para editar el teléfono de este repartidor.",
  DRIVER_NOT_FOUND:
    "No encontramos al repartidor. Puede que ya no esté activo en tu operación.",
  PHONE_IN_USE:
    "Ese número ya está registrado en otro usuario. Verifica que sea el correcto.",
  CONTACT_LINKED_TO_OTHER_DRIVER:
    "Ese número ya está asociado a otro repartidor en la mesa de ayuda.",
  DRIVER_DIRECTORY_UNAVAILABLE:
    "No pudimos consultar el directorio de repartidores. Intenta de nuevo en unos minutos.",
  FORBIDDEN_ROLE: "Tu rol no puede realizar esta acción.",
  SESSION_REQUIRED: "Tu sesión expiró. Vuelve a iniciar sesión.",
  PHONE_NOT_OF_DRIVER:
    "Ese número no pertenece al repartidor. Elige uno de la lista o agrégalo primero.",
  CHANNEL_NOT_CONNECTED:
    "No hay un WhatsApp conectado para enviar mensajes. Conéctalo en Canales y vuelve a intentar.",
  RECIPIENT_NOT_ON_WHATSAPP:
    "Ese número no tiene WhatsApp. Prueba con otro número del repartidor.",
  SEND_IN_PROGRESS:
    "Este mensaje ya se está enviando. Espera unos segundos y revisa la conversación.",
  OUTCOME_UNKNOWN:
    "No pudimos confirmar si el mensaje salió; revisa la conversación antes de reenviar.",
  CHANNEL_UNAVAILABLE:
    "El canal de WhatsApp no está disponible por ahora. Intenta de nuevo en unos minutos.",
  TEMPORARILY_UNAVAILABLE:
    "El servicio no está disponible por ahora. Intenta de nuevo en unos minutos.",
};

const RATE_LIMITED_WITH_SECONDS =
  "Enviaste demasiados mensajes seguidos. Espera {{seconds}} s e intenta de nuevo.";
const RATE_LIMITED = "Enviaste demasiados mensajes seguidos. Espera un momento e intenta de nuevo.";
const NETWORK = "No pudimos conectar con el servidor. Revisa tu conexión e intenta de nuevo.";
const VALIDATION = "Revisa los datos ingresados e intenta de nuevo.";
const FALLBACK = "No se pudo completar la acción. Intenta de nuevo.";

/**
 * @param {{status?: number|null, code?: string|null, retryAfterSeconds?: number|null, network?: boolean}|null|undefined} error
 * @param {(key: string) => string} t
 * @returns {string}
 */
export function driverMessagingErrorText(error, t) {
  if (!error) return t(FALLBACK);
  if (error.code === "RATE_LIMITED" || (!error.code && error.status === 429)) {
    return error.retryAfterSeconds
      ? t(RATE_LIMITED_WITH_SECONDS).replace("{{seconds}}", String(error.retryAfterSeconds))
      : t(RATE_LIMITED);
  }
  if (error.code && BY_CODE[error.code]) return t(BY_CODE[error.code]);
  if (error.network) return t(NETWORK);
  if (error.status === 400 || error.status === 422) return t(VALIDATION);
  if (error.status === 403) return t(BY_CODE.FORBIDDEN_ROLE);
  if (error.status === 404) return t(BY_CODE.DRIVER_NOT_FOUND);
  if (error.status === 503) return t(BY_CODE.TEMPORARILY_UNAVAILABLE);
  return t(FALLBACK);
}
